// extracted by mini-css-extract-plugin
module.exports = {"recButton":"QuickReply_recButton__3xVrh"};